/* eslint-disable */
import { Component } from '@angular/core';
import { FlowManagerService } from '../../shared/services/flowmanager.service';
import { ModalService } from '../../shared/services/modal.service';
import { ApplicationActions } from '../../actions/application.actions';
import { Router } from '@angular/router';

@Component({
  selector: 'ns-valueprop',
  template: require('./valueprop.component.html')
})

export class ValuepropComponent {

  constructor(
    flowManager: FlowManagerService,
    modalService: ModalService,
    router: Router,
    appAction: ApplicationActions) {
    this.appAction = appAction;
    this.router = router;
    this.modalService = modalService;
    this.flowManager = flowManager;
    this.flowManagerSubscription = flowManager.valuePropCopyChange.subscribe(event => {
      this.currentValue = event;
    });
    this.appAction = appAction;
  }

  ngOnInit() {
    if (this.appAction.getData('appType') === 'tka') this.tka = true;
  }

  ngOnDestroy() {
    this.flowManagerSubscription.unsubscribe();
  }
}
